import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateEventDeliveryAddressMutationVariables = Types.Exact<{
  delivery_address_id: Types.Scalars['ID'];
  input: Types.UpdateEventDeliveryAddressInput;
}>;


export type UpdateEventDeliveryAddressMutation = { __typename?: 'Mutation', updateEventDeliveryAddress: { __typename?: 'EventDeliveryAddress', id: string, name?: string | null, event_id?: string | null, is_event_default: boolean, linked_item_location_count: number } };


export const UpdateEventDeliveryAddressDocument = gql`
    mutation UpdateEventDeliveryAddress($delivery_address_id: ID!, $input: UpdateEventDeliveryAddressInput!) {
  updateEventDeliveryAddress(
    delivery_address_id: $delivery_address_id
    input: $input
  ) {
    id
    name
    event_id
    is_event_default
    linked_item_location_count
  }
}
    `;
export type UpdateEventDeliveryAddressMutationFn = Apollo.MutationFunction<UpdateEventDeliveryAddressMutation, UpdateEventDeliveryAddressMutationVariables>;

/**
 * __useUpdateEventDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useUpdateEventDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDeliveryAddressMutation, { data, loading, error }] = useUpdateEventDeliveryAddressMutation({
 *   variables: {
 *      delivery_address_id: // value for 'delivery_address_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventDeliveryAddressMutation, UpdateEventDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventDeliveryAddressMutation, UpdateEventDeliveryAddressMutationVariables>(UpdateEventDeliveryAddressDocument, options);
      }
export type UpdateEventDeliveryAddressMutationHookResult = ReturnType<typeof useUpdateEventDeliveryAddressMutation>;
export type UpdateEventDeliveryAddressMutationResult = Apollo.MutationResult<UpdateEventDeliveryAddressMutation>;
export type UpdateEventDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<UpdateEventDeliveryAddressMutation, UpdateEventDeliveryAddressMutationVariables>;